import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AppConstants } from 'appshared/app-constants';
// import * as Models from 'appshared/models/shared';
import { RoleGuard } from 'client/app/guards/role.guard';
import { LoginLogsComponent } from './login-logs.component';
import { UsersResolverService } from '../users/users-resolver.service';

const routes: Routes = [
	{
		path: '', component: LoginLogsComponent, canActivate: [RoleGuard],
		data: { role: AppConstants.staffUserRole }, resolve: [UsersResolverService]
	}
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class LoginLogsRoutingModule { }
